import React, { useRef, useState, useEffect } from 'react';

import './Card.css';

/**
 * Card component with glass effect and image
 * @param {Object} props
 * @param {string} props.title - Title of the card
 * @param {string} props.description - Description text
 * @param {string} props.coverImage - URL/path to cover image
 * @param {string} props.coverImagePosition - CSS object-position value
 * @returns {JSX.Element} Card with glass cover and background
 */
function Card({ ...props }) {
  const ref = useRef();
  const [isIntersecting, setIntersecting] = useState(false);

  useEffect(() => {
    console.log(ref);
    if (ref) {
      const observer = new IntersectionObserver(([entry]) => {
        setIntersecting(entry.isIntersecting);
      });

      observer.observe(ref.current);
      return () => {
        observer.disconnect();
      };
    }
  }, [ref]);

  return (
    <div
      ref={ref}
      className={`card ${props.className}  transition-opacity ease-in duration-700 ${
        isIntersecting ? 'opacity-100' : 'opacity-0 '
      }`}
      onClick={props.onClick}
    >
      <div className="glass-cover">
        <p className="text-2xl font-semibold">{props.title}</p>
        <p className="text-xl font-medium">{props.description}</p>
        <p>{props.extras}</p>
      </div>
      <img src={props.coverImage} style={{ objectPosition: `${props.coverImagePosition}` }} alt="" />
    </div>
  );
}

export default Card;
